<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="feed"></ion-back-button>
    </ion-buttons>
    <ion-title role="heading" aria-level="1" mode="md">
      {{ 'page.notifications' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="app__content notifications">
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="notifications__list" *ngIf="notifications.length > 0">
      <div
        *ngFor="let notification of notifications"
        class="notification"
        role="link"
        tabindex="0"
        (click)="openNotification(notification)"
      >
        <div class="notification__image">
          <img
            *ngIf="!notification.project"
            appImgFallback
            [src]="whitelabelIcon"
            width="40"
            height="40"
            alt="{{ whitelabelName }}"
          />
          <img
            *ngIf="notification.project?.logoThumbnails"
            appImgFallback
            [src]="notification.project.logoThumbnails.small"
            width="40"
            height="40"
            alt="{{ notification.project.name }}"
          />
          <img
            *ngIf="!notification.project?.logoThumbnails"
            appImgFallback
            [src]="
            notification.project?.customer.logoThumbnails?.small ||
            notification.customer?.logoThumbnails?.small"
            width="40"
            height="40"
            alt="{{ notification.project?.name || notification.customer?.name }}"
          />
        </div>
        <div class="notification__text">
          <h2 *ngIf="notification.title">{{ notification.title }}</h2>
          <div [innerHTML]="notification.body"></div>
          <span>{{ notification.createdAt | timeAgo }} </span>
        </div>
      </div>
    </div>
    @if (notifications.length === 0 && notificationsLoaded) {
    <app-state-notice
      iconPath="/assets/illustrations/no_new_notifications.svg"
      [title]="'notifications.empty.title' | translate"
      [desc]="'notifications.empty.desc' | translate"
    />
    }
    <ion-infinite-scroll
      [hidden]="notifications?.length == totalItems"
      (ionInfinite)="loadNotifications($event)"
    >
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
  <app-loader
    [full]="true"
    [loading]="!notificationsLoaded"
    [hidden]="notifications?.length > 0"
  ></app-loader>
</ion-content>
